import styled, { css } from "styled-components"

import IntersectionChecker from "components/containers/common/IntersectionChecker"
import SVGIcon from "components/presenters/common/SVGIcon"

export default function ProductDetailFooter({
  changeCurrTabByScroll,
  onClickPolicyBtn,
  onClickVendorBtn,
}) {
  return (
    <>
      <IntersectionChecker
        options={{ rootMargin: "0px 0px 0px 0px" }}
        onBottomIntersectIn={() => {
          if (changeCurrTabByScroll) changeCurrTabByScroll("qa")
        }}
      />
      <Block id="qa">
        <BtnList>
          <BtnItem>
            <KakaoLink href="http://pf.kakao.com/_gmtJs/chat" target="_blank">
              문의
              <IconBlock>
                <SVGIcon name="arrow" />
              </IconBlock>
            </KakaoLink>
          </BtnItem>
          <BtnItem onClick={onClickPolicyBtn}>
            <ProductPolicyToggleBtn>
              배송/교환/반품
              <IconBlock>
                <SVGIcon name="arrow" />
              </IconBlock>
            </ProductPolicyToggleBtn>
          </BtnItem>
          <BtnItem onClick={onClickVendorBtn}>
            <ProductPolicyToggleBtn>
              판매자 정보
              <IconBlock>
                <SVGIcon name="arrow" />
              </IconBlock>
            </ProductPolicyToggleBtn>
          </BtnItem>
        </BtnList>
      </Block>
      <IntersectionChecker
        options={{ rootMargin: "0px 0px 0px 0px" }}
        onBottomIntersectIn={() => {
          if (changeCurrTabByScroll) changeCurrTabByScroll("qa")
        }}
      />
    </>
  )
}

const Block = styled.div`
  border-top: calc(100vw * (8 / 375)) solid #f7f7f7;
  margin: 0 calc(100vw * (-20 / 375));
`

const BtnList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 calc(100vw * (20 / 375));
`

const BtnItem = styled.li`
  svg {
    fill: #828282;
  }
`

const buttonStyle = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: calc(100vw * (2 / 375));
  padding-top: calc(100vw * (15 / 375));
  padding-bottom: calc(100vw * (17 / 375));
  font-weight: 700;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #121212;
`

const KakaoLink = styled.a`
  ${buttonStyle}
`

const ProductPolicyToggleBtn = styled.div`
  ${buttonStyle}
`

const IconBlock = styled.div`
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (14 / 375));
  svg {
    color: #828282;
  }
`
